import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { GrowlerService } from '../../../../../services/growler.service';
import { BankAccountsService } from '../../../../../services/financial-accounts/bank-accounts.service';
import { ValidationMessageService } from '../../../../../services/validation-message.service';
import { BankAccountPropertiesComponent } from '../bank-account-properties/bank-account-properties.component';

export interface AddOrgBankAccountDialogInput
{
    onlyDepositAccounts?: boolean;
}

export interface AddOrgBankAccountDialogResult
{
    success: boolean;
}

@Component({
    selector: 'app-add-org-bank-account-dialog',
    templateUrl: './add-org-bank-account-dialog.component.html',
})
export class AddOrgBankAccountDialogComponent
{
    @ViewChild('propertiesForm') propertiesForm: BankAccountPropertiesComponent;

    isSaveInFlight = false;

    constructor(
            private _bankAccountsService: BankAccountsService,
            private _dialogRef: MatDialogRef<AddOrgBankAccountDialogComponent>,
            private _growler: GrowlerService,
            private _validationMessageService: ValidationMessageService,
            @Inject(MAT_DIALOG_DATA) public data: AddOrgBankAccountDialogInput,
    ) {
    }

    saveAccount() {
        if (!this.propertiesForm.isValid()) {
            return;
        }

        const request = this.propertiesForm.getFormValue();

        this.isSaveInFlight = true;
        this._bankAccountsService.createOrganizationBankAccount(
                null,
                request,
        ).subscribe({
            next: () => {
                this._dialogRef.close(<AddOrgBankAccountDialogResult>{
                    success: true,
                });
                this._growler.success('Success', 'We have successfully added your bank account');
            },
            error: (error) => {
                this.isSaveInFlight = false;
                this._growler.oops(this._validationMessageService.extractResponseErrorText(error));
            },
        });
    }

    closeDialog() {
        this._dialogRef.close(<AddOrgBankAccountDialogResult>{success: false});
    }
}
